import { createTheme } from '@mui/material/styles';
import { themeOptions } from './theme-options';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    xxl: true;

    cxxl: true;
    cxl: true;
    clg: true;
    cmd: true;
    csm: true;
    cxs: true;
  }
}

const { typography, ...other } = themeOptions;
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      xxl: 1850,

      cxs: 390,
      csm: 600,
      cmd: 1000,
      clg: 1366,
      cxl: 1920,
      cxxl: 2440
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        disableGutters: ({ theme }) => ({
          paddingLeft: 0,
          paddingRight: 0,
          [theme.breakpoints.up('sm')]: {
            paddingLeft: 0,
            paddingRight: 0,
          },
        }),
        root: ({ theme }) => ({
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),
          [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
          },
        }),
      },
    },
  },
  typography: {
    fontFamily: 'Quicksand, sans-serif',
    h1: {
      fontSize: '1.5rem',
    },
    h2: {
      fontSize: '1.25rem',
    },
    h3: {
      fontSize: '1.25rem',
    },
    h4: {
      fontSize: '1.25rem',
    },
    h5: {
      fontSize: '1.25rem',
    },
    h6: {
      fontSize: '1.25rem',
    },
    subtitle1: {
      fontSize: '1rem',
    },
    subtitle2: {
      fontSize: '1rem',
    },
    body1: {
      fontSize: '1rem',
    },
    body2: {
      fontSize: '1rem',
    },
    ...typography,
  },
  ...other,
});

export default theme;
